<template>
  <div class="steps-template">
    <div class="steps">
      <div class="step is-center" v-for="(item, index) in stepItems" :key="index" :style="{flexBasis:(index==1?'60%':'20%')}">
        <div class="step__head" :class="{'is-finish':!(index>activeStep)}">
          <div class="step__line" :class="{'last-step':index==(stepItems.length-1)}" :style="{right:(index==0?'-150%':(index==1?'-17%':'-50%'))}">
            <i class="step__line-inner" :class="[index<activeStep?'is-finish':'is-wait']"></i>
          </div>
          <div class="step__icon" :class="{'is-finish':!(index>activeStep)}"></div>
        </div>
        <div class="step__main">
          <div class="step__title" :class="{'is-finish':!(index>activeStep)}">{{ item.name }}</div>
          <div class="step__description" :class="{'is-finish':!(index>activeStep)}">{{ item.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*!
  * 步骤条控件（仿el-steps）： 
  *
  * 参数：stepItems 步骤条内容 [{name: , description:,}], activeStep 激活项
  * 
  */
export default {
  data() {
    return {};
  },
  props: {
    stepItems: { type: Array, default: [] },
    activeStep: { type: Number, default: 0 }
  }
};
</script>


